import client from '../client'

export async function removeFromFavorites({ vehicleId }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/FavoriteVehicles/Remove`, {
    headers: { 'Content-Type': 'application/json ' },
    method: 'POST',
    body: JSON.stringify({ vehicleId }),
  })
}
